import React, { useEffect, useState } from 'react';
import { actionTypesSelect, spotOnlyActions, futuresOnlyActions } from '../../../../utils/ActionUtils';
import { getCurrentMarket, MARKET_FUTURES } from '../../../../utils/MarketStorage';

/**
 * props:
 * - type
 * - onChange
 * Mostra só os tipos de ação do MERCADO atual: no Spot esconde FUTURES_ORDER;
 * nos Futuros esconde os tipos de spot (Enviar Ordem/Trailing/Saque).
 */
function ActionType(props) {

    const [type, setType] = useState('');
    const isFutures = getCurrentMarket() === MARKET_FUTURES;
    const hidden = isFutures ? spotOnlyActions : futuresOnlyActions;

    useEffect(() => {
        setType(props.type);
    }, [props.type])

    return (
        <select id="type" className='form-select' value={type} onChange={props.onChange}>
            {
                Object.entries(actionTypesSelect)
                    .filter(prop => !hidden.includes(prop[0]))
                    .map(prop => (<option key={prop[0]} value={prop[0]}>{prop[1]}</option>))
            }
        </select>
    )
}

export default ActionType;
